$(function () {
    $('.block-newsletter').find('#save').on('click', addToNewsletter);
    $('.block-newsletter').find('input').on('keyup', function (e) {
        if (e.keyCode === 13) {
            addToNewsletter();
        }
    });
});

function addToNewsletter(){
    let email_regex = new RegExp('^([0-9a-zA-Z]+[-._+&amp;])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$', 'i');
    let fname = $('#newsletter-fname').val();
    let lname = $('#newsletter-lname').val();
    let email = $('#newsletter-email').val();
    error = false;
    if (fname === '') {
        error = true;
        $('#newsletter-fname').addClass('error');
    }
    if (lname === '') {
        error = true;
        $('#newsletter-fname').addClass('error');
    }
    if (!email_regex.test(email)) {
        error = true;
        $('#newsletter-email').addClass('error');
    }
    if (!error) {
        $.post('/newsletter/add/', {fname: fname, lname: lname, email: email}, function () {
            $('.block-newsletter').find('.thnx').addClass('active');
        });
    }
}
